import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ProjectService } from 'src/app/services/project.service';
import { EventService } from 'src/app/services/event.service';
import { JobService } from 'src/app/services/job.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ForumService } from 'src/app/services/forum.service';

@Component({
  selector: 'app-my-lists',
  templateUrl: './my-lists.component.html',
  styleUrls: ['./my-lists.component.scss'],
})
export class MyListsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  user;
  locked = false;
  listId: string;
  listLabel: string;
  listSingle: string;
  cardWidth = 6;
  list: Array<any> = [];

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private projectService: ProjectService,
    private eventService: EventService,
    private institutionService: InstitutionService,
    private jobService: JobService,
    private discussionService: ForumService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.listId = params.id;
      this.listLabel = this.listId.substring(0, 1).toUpperCase() + this.listId.substring(1);
      this.listSingle = this.listId.substring(0, this.listId.length - 1);
      this.analyticsService.event(`my_${this.listId}_view`);

      this.subscriptions.add(
        this.userService.user.subscribe((u) => {
          if (u && u.uid) {
            this.user = u;
            this.locked = false;

            // Get user owned posts
            this[this.listSingle + 'Service']['getCurrentUserOwned' + this.listLabel](this.user.uid).subscribe(
              (l) => {
                this.list = this.list.concat(l);
              },
              (e) => console.error(e)
            );

            // Get posts user is participating in
            if (this.listId !== 'jobs') {
              this[this.listSingle + 'Service']
                ['getCurrentUser' + this.listLabel](this.user[this.listId])
                .subscribe((arr) => {
                  if (arr.length) {
                    arr.forEach((i$) => {
                      i$.subscribe((i) => {
                        if (i && !this.list.some((li) => li.id === i[0].id)) {
                          this.list.push(i[0]);
                        }
                      });
                    });
                  }
                });
            }
          } else {
            this.locked = true;
          }
        })
      );
    });

    switch (this.listId) {
      case 'projects':
        this.cardWidth = 6;
        break;
      case 'institutions':
        this.cardWidth = 6;
        break;
      case 'events':
        this.cardWidth = 4;
        break;
      case 'jobs':
        this.cardWidth = 12;
        break;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
